<template>

	<div class="content background1" style="display: flex">
		<!-- 左 -->
		<div class="tableBox9" ref="menuResize" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table newTable">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<!-- <el-tab-pane label="设备类型" name="first">
              <template v-if="treeShow">
                <tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes" ref="treeDisplay"></tree>
              </template>
            </el-tab-pane> -->
						<el-tab-pane :label="$t('label_161')" name="second" width="100%">
							<template v-if="treeShow">
								<tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
<!--                <tree :dataTree="treeData2" :treeType="1" :pink="1" @getDeviceMes="getDeviceMes"-->
<!--                      ref="treeDisplay2"></tree>-->
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>

			<!-- <div class="dragBox" ref="dragResize"></div> -->
		</div>
		<!-- 右 -->
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<!-- <img style="width:100%;height:100%;" src="../../../static/img/buttonRight.png"> -->
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" ref="operaResize" :style="{'padding':width=='0px'?'0':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes">
						<p class="title" style="padding: 10px 10px 0 10px"><span class="spot">{{'<'+(deviceDetailMes.name==undefined?$t('label_272'):deviceDetailMes.name)+">"}}</span>
							{{$t('label_517')}}</p>
						<div class="table" style="height: 96%;padding: 0;">
							<!-- 主 -->
							<div class="tabs_style kpidetail" style="height: 100%;">
								<!-- 上 -->
								<el-tabs v-model="activeNameSpot">
									<el-tab-pane :label="$t('label_189')" name="inspectionEquipment" v-if="MenuRoleList.indexOf('408')>=0" style="height: 100%;">
										<kpiList ref="kpiDisplay"></kpiList>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_845')" name="pro" v-if="MenuRoleList.indexOf('410')>=0">
										<kpiDetails ref="paramDisplay"></kpiDetails>
									</el-tab-pane>
								</el-tabs>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import tree from "@/components/list/tree/equTree.vue";
  // import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
	import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import partInfo from "@/components/list/displayPage/partInfoParam";
	import common from "@/assets/js/common/common.js";
	import organizationTabJs from "@/assets/js/system/organizationTab.js";
	import kpiDetails from "../../components/list/KPI/kpiDetails";
	import kpiList from "../../components/list/KPI/kpiList";
	import daily from "../../components/list/equipmentDetails/daily"; //  临时测试
	import weekly from "../../components/list/equipmentDetails/weekly"; //  临时测试
	import monthlyReport from "../../components/list/equipmentDetails/monthlyReport"; //  临时测试
	import annualReport from "../../components/list/equipmentDetails/annualReport"; //  临时测试
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js";
	import $ from 'jquery'
	export default {
		name: 'kpiStatistics',
		components: {
			Page,
			calendar,
			tree,
			checkItem,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			partInfo,
			kpiDetails, // KPI详细内容
			kpiList, // KPI报告列表
			daily,
			weekly,
			monthlyReport,
			annualReport
		},
		data() {
			return {
				eqDetail: false,
				eqDetailInfo: {},
				activeNameSpot: 'inspectionEquipment',
				getTreeMes: '0',
				treeShow: true,
				MenuRoleList: [],
				deviceDetailMes: {},
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				checked: false,
				cardData: [],
				activeNameTree: 'second',
				searchDataList: {},
				beginTime: '',
				endTime: '',
				workTime: {},
				width: '340px',
				qrCodeShow: false,
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {

			showBtn() {
				console.log(111)
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
					//this.$refs.menuResize.style.width = "0px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth +"px";
				} else {
					this.width = "340px";
					//this.$refs.menuResize.style.width = "340px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth -340 +"px";
				}
			},
			//显示设备详细信息
			showDetail: function(data) {
				this.eqDetail = true;
				this.eqDetailInfo = data;
			},
			dropSize() {
				let that = this,
					menuWidth = 200,
					operaHeight = 200;
				// this.$refs.dragResize.onmousedown = function() {
				// 	document.onmousemove = function(e) {
				// 		let clientX = e.clientX;
				// 		// 最大宽度
				// 		if (clientX >= 800) {
				// 			clientX = 800;
				// 		}
				// 		// 最小宽度
				// 		if (clientX <= 495) {
				// 			clientX = 495;
				// 			menuWidth = clientX - 30;
				// 		}
				// 		that.$refs.menuResize.style.width = clientX - 275 + "px";
				// 		that.$refs.operaResize.style.width = window.screen.width - clientX + 35 + "px";
				// 		document.onmouseup = function() {
				// 			document.onmousemove = null;
				// 			document.onmouseup = null;
				// 			that.releaseCapture && that.releaseCapture()
				// 		}
				// 	}
				// }
			},
			// 顶部导航
			handleSelect(key, keyPath) {
				console.log(key, keyPath);
			},
			//从属于
			loadTree(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							resolve(res);
						}
					});
				}
			},
			treeCheck(data, checked, indeterminate) {
				if (checked) {
					this.formModel.organizationId = data.id;
					this.cardData.deptId = data.id;
					this.$refs.tree.setCheckedKeys([data.id], true)
					this.selectDept(data.id);
					this.$refs.selectTree1.blur()
				}

			},


			changeTime(value) {
				let arr = value;
				if (arr == null || arr == "") {
					return "-";
				} else {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i].toString().length == 1) {
							arr[i] = "0" + arr[i];
						}
					}
					if (arr.length == 5) {
						var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + "00";
					} else {
						var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + arr[5];
					}
					return getFormatTime;
				}
			},

			getDeviceMes(data) {
				this.eqDetail = false;
				this.getTreeMes = '0';
				this.searchDataList = {}
				this.deviceDetailMes = {}
				if (data.name == this.$t('label_272') || data.type == '2') { //区域
					this.deviceDetailMes.type = 2;
				} else if (data.type == '1') { //设备
					this.deviceDetailMes.type = data.type;
				}
				this.deviceDetailMes.name = data.name;
				this.deviceDetailMes.id = data.id;
				this.$nextTick(function() {
					this.$refs.kpiDisplay.newMes(this.deviceDetailMes, this.workTime, '');
					this.$refs.paramDisplay.newMes(this.deviceDetailMes, this.workTime, '');
				})
			},
			showDeviceMes(data) {
				this.$refs.treeDisplay.showCard(data.id);
				/*this.getTreeMes = '3';
				this.selectCard(data.id);
				this.getEquipmentParameter(data.id);
				this.$nextTick(() => {
				  this.$refs.checkItemDisplay.newMes(data.id);
				  this.$refs.maintenanceItemDisplay.newMes(data.id);
				  this.$refs.inspectionItemDisplay.newMes(data.id, 0);
				  this.$refs.electronDocumentDisplay.newMes(data.id);
				  this.$refs.partInfoDisplay.newMes(data.id);
				  this.searchDeviceMesDetail();
				})*/
			},




			handleClickTree(tab, event) {
				/*if (tab.label == '区域') {
				  this.getTreeMes = '0';
				} else {

				}*/
				this.getTreeMes = '0';
				this.searchDataList = {}
				this.deviceDetailMes = {}
				this.deviceDetailMes.name = this.$t('label_272')
				this.search()
			},
			//查询上下班时间
			getWorkTime: function() {
				equipmentMonitoringService.getWorkTime().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.workTime = data.data;
					};
				}).catch((response) => {
					console.log(response)
				})
			},
		},
		mounted() {
			this.$nextTick(() => {
				this.dropSize();
			})
		},
		created() {
			this.getWorkTime();
			this.MenuRoleList = this.$store.getters.getMenu;

		}
	}
</script>

<style>
	.tabs_style .el-tabs__item {
		width: 140px;
		text-align: center;
		font-size: 17px;
		letter-spacing: 3px;
		font-weight: bold;
		height: 50px;
		line-height: 50px;
	}

	.tabs_style .el-tabs__active-bar {
		background-color: #45c4a1;
		height: 4px;
		padding: 0 30px;
	}

	.tabs_style .el-tabs__item.is-active {
		color: #45c4a1;
	}

	.tabs_style .el-tabs__item:hover,
	.tableBox9 .el-tabs__item:hover {
		color: #45c4a1;
	}

	.checkBoxs {
		width: 12px;
		height: 12px;
		float: left;
		margin-top: 4px;

	}

	.el-tabs {
		height: 100%;
	}

	.el-tabs__content {
		height: calc(100% - 58px);
	}

	.background1 .treeMes .kpidetail .el-tabs__content {
		height: 90%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentOperation/kpiStatistics.vue